import { html, render } from 'lit-html'
import AuthBase from '../auth_base'
import '@polleverywhere/pe-button'

function handleProviderClicked (issuer) {
  this.trigger('click:provider', { url: issuer })
  this.trigger('view:action', 'click:samlLoginButton', { multi_step: true }, { immediate: true })
}

/**
 * This component will show one or more button links to saml providers
 *
 * @event click:identity User clicked username
 *
 * @event click:auth_password User clicked toggle to password
 *
 * @event view:action View action events
 *   @param {String} name Event name
 *   @param {Object} data Event data
 *   @param {Object} options Event options
 */
export default class AuthSaml extends AuthBase {
  get className () { return 'component-auth__multi-step-login__auth-saml' }
  get fields () {
    return ['multi-step-login-authenticate-username']
  }

  get template () {
    // Returning null because we are not calling super.render()
    return null
  }

  get events () {
    return {
      'click pe-text-field[name="username"]': () => this.trigger('click:identity')
    }
  }

  /**
   * @param {Object} options Configuration options.
   * @param {String} options.username Prefilled read-only username
   * @param {Object} options.userCheck Account specific auth settings
   */
  initialize (options = {}) {
    if (!options.username || !options.username.length) {
      throw Error('Non empty username string must be passed in')
    }

    if (typeof options.userCheck !== 'object') {
      throw new TypeError('userCheck must be passed in')
    }

    this.options = options
    this.userCheck = options.userCheck

    super.initialize()
  }

  render () {
    this.trigger('view:action', 'view:auth', {
      className: this.className
    })

    this.trigger('view:action', 'view:samlLoginButton', {
      multi_step: true,
      force_saml: this.userCheck.force_saml
    })

    const samlButtons = this.userCheck.login_labels.map(({ label, issuer }) => {
      return html`
        <pe-button
          label=${`Log in with ${label}`}
          data-sso-provider=true
          class=${this.className}__provider
          @click=${() => handleProviderClicked.call(this, issuer)}
        ></pe-button>
      `
    })

    const canUsePassword = !this.userCheck.force_saml && this.userCheck.exists
    render(html`
      <div class='component-auth__form'>${this.form.render().$el}</div>
      <div class='component-auth__multi-step-login__auth-saml__sso'>${samlButtons}</div>
      <div class='component-auth__error' role='alert'></div>
      ${canUsePassword ? html`
        <pe-button
          type='link'
          class=${this.className}__password
          label='Use password instead'
          @click=${() => this.trigger('click:use_password')}
        ></pe-button>
      ` : null}
    `, this.el)

    this.el.querySelector('pe-text-field[name="username"]').setAttribute('value', this.options.username)
    return this
  }
}
